import config from 'config';
import tmpl from './create.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'focus textarea': 'scrollToEventTarget',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',
	},

	initialize: function()
	{
		// Mettre à jour le formulaire quand le réseau change
		this.listenTo( app, 'online', this.render );
	},


	onSubmit: function( evt )
	{
		evt.preventDefault();

		// Création impossible hors réseau
		if( !app.is('online') )
		{
			return;
		}

		var data = this.$('form').serializeJSON();
		this.$(':input, button').prop('disabled',true);

		this.model.set( data );
		if( !this.model.isValid() )
		{
			this.$(':input, button').prop('disabled',false);
			return this.render();
		}

		data = this.model.toJSON();

		var registering = $.ajax({
			url: config.url.register,
			method: 'POST',
			contentType: 'application/json',
			data: JSON.stringify( data ),
		}).then( function( response )
		{
			return app.signin( response, 'Création de votre compte' );
		});

		registering.done(function()
		{
			app.redirect( 'user/account' );
		});

		registering.fail(_.bind(function( xhr )
		{
			this.model.setErrors( xhr.responseJSON );
			this.$(':input, button').prop('disabled',false);
			this.render();
		},this));

		app.addMessage( 'Création de votre compte', registering );
	},


	render: function()
	{
		this.doRender({
			user: this.model,
			data: app.getStore('data')
		});
	}

});
